import React, { useState } from "react";
import {
  Button,
  TextField,
  Rating,
  Box,
  styled,
  Stack,
  Typography,
} from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import ActionDialog from "../ActionDialog";
import Lotties from "../Lotties";
import WavingLotties from "../../assets/lottie/waving_hands.json";
import { postReview } from "../../redux/actions/review";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import ModalNotification from "../ModalNotification";
const ReviewDialog = ({
  actPostReview,
  statePasienId,
  open,
  setOpen,
  rkunId = "",
}) => {
  const [form, setForm] = useState({
    rating: 0,
    comment: "",
    rkun_id: rkunId,
  });

  const [modals, setModals] = useState({
    google: false,
  });

  const [message, setMessage] = useState(
    `"Hai, berikan kritik & saran agar kami lebih baik 😊"`
  );

  React.useEffect(() => {
    switch (form.rating) {
      case 1:
        setMessage(
          "Hmm, mohon maaf atas ketidaknyamanannya, kami akan berusaha lebih baik 🙏"
        );
        break;
      case 2:
        setMessage(
          "Terima kasih atas masukannya, kami akan segera perbaiki 🙂"
        );
        break;
      case 3:
        setMessage("Terima kasih, semoga ke depan bisa lebih baik lagi 😊");
        break;
      case 4:
        setMessage(
          "Terima kasih banyak, senang mendengar pengalaman Anda positif 🙌"
        );
        break;
      case 5:
        setMessage(
          "Woahh, terima kasih! Kami senang bisa memberi yang terbaik 💖"
        );
        break;
      default:
        break;
    }
    // setMessage({

    // });
    return () => {};
  }, [form.rating]);

  const StyledRating = styled(Rating)(({ theme }) => ({
    "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
      color: theme.palette.action.disabled,
    },
  }));

  const customIcons = {
    1: {
      icon: (
        <SentimentVeryDissatisfiedIcon
          color="error"
          sx={{
            fontSize: "35px",
          }}
        />
      ),
      label: "Very Dissatisfied",
    },
    2: {
      icon: (
        <SentimentDissatisfiedIcon
          color="error"
          sx={{
            fontSize: "35px",
          }}
        />
      ),
      label: "Dissatisfied",
    },
    3: {
      icon: (
        <SentimentSatisfiedIcon
          color="warning"
          sx={{
            fontSize: "35px",
          }}
        />
      ),
      label: "Neutral",
    },
    4: {
      icon: (
        <SentimentSatisfiedAltIcon
          color="success"
          sx={{
            fontSize: "35px",
          }}
        />
      ),
      label: "Satisfied",
    },
    5: {
      icon: (
        <SentimentVerySatisfiedIcon
          color="success"
          sx={{
            fontSize: "35px",
          }}
        />
      ),
      label: "Very Satisfied",
    },
  };

  function IconContainer(props) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
  }

  const handleSubmit = () => {
    // if (form.rating == 5) {
    //   return window.open(process.env.REACT_APP_GOOGLE_REVIEW_LINK, "_blank");
    // }

    return actPostReview(
      {
        rating: form.rating,
        comment: form.comment,
        rkun_id: form.rkun_id,
        ps_id: statePasienId,
      },
      () => {
        toast("Tersimpan", { type: "success" });
        setOpen(false);
        setForm({
          rating: 0,
          comment: "",
          rkun_id: rkunId,
        });

        if (form.rating == 5) {
          setModals((prev) => {
            return {
              ...prev,
              google: true,
            };
          });
          // return window.open(process.env.REACT_APP_GOOGLE_REVIEW_LINK, "_blank");
        }

        // if (form.rating == 5) {
        //   return window.open(
        //     process.env.REACT_APP_GOOGLE_REVIEW_LINK,
        //     "_blank"
        //   );
        // }
      }
    );
  };

  // React.useEffect(() => {
  //   if (form.rating == 5) {
  //     setModals((prev) => {
  //       return {
  //         ...prev,
  //         google: true,
  //       };
  //     });
  //     // return window.open(process.env.REACT_APP_GOOGLE_REVIEW_LINK, "_blank");
  //   }

  //   return () => {};
  // }, [form.rating]);

  return (
    <>
      <ModalNotification
        open={modals.google}
        setOpen={(val) =>
          setModals((prev) => {
            return {
              ...prev,
              google: val,
            };
          })
        }
        title={"Senang Anda puas dengan layanan kami! ⭐"}
        subtitle={
          "Jika berkenan, yuk bagikan pengalaman Anda di Google — review Anda sangat berarti bagi kami 🙏"
        }
        img={WavingLotties}
        type={"lottie"}
        continueText="Ya, review ⭐"
        abortText="Mungkin nanti"
        actContinue={() =>
          window.open(process.env.REACT_APP_GOOGLE_REVIEW_LINK, "_blank")
        }
      />
      <ActionDialog open={open} label="Kritik & Saran" setOpen={setOpen}>
        <Stack spacing={2}>
          <Box height="1vh"></Box>
          <Lotties file={WavingLotties} size="small" loop={true} />
          <Typography variant="body1" align="center">
            {message}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <StyledRating
              IconContainerComponent={IconContainer}
              name="review-rating"
              value={form.rating}
              getLabelText={(value) => customIcons[value].label}
              onChange={(event, newValue) =>
                setForm({
                  ...form,
                  rating: newValue,
                })
              }
              highlightSelectedOnly
            />
          </Box>
          <TextField
            multiline
            rows={3}
            placeholder="Masukkan saran dan kritik anda"
            value={form.comment}
            onChange={(e) =>
              setForm({
                ...form,
                comment: e.target.value,
              })
            }
          />
          <Button
            variant="contained"
            disabled={!form.rating}
            onClick={handleSubmit}
          >
            Simpan
          </Button>
        </Stack>
      </ActionDialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    statePasienId: state.antrian.detail
      ? state.antrian.detail.pasien.id
      : state.auth.user.ps_id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actPostReview: (body, succ) => dispatch(postReview(body, succ)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewDialog);
